var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-aspect-ratio',[_c('div',{staticClass:"centered-vertical-element video__container"},[_c('video',{ref:"videoElement",staticClass:"presentation__video",attrs:{"playsinline":"","autoplay":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }